module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('div', {
    staticClass: "service-content no-nav content"
  }, [_c('p', [_vm._v("\n            Gulf Coast has the capability and skilled staff to coordinate and properly install the full scope\n            of your landscape project. For years, we have given property owners, managers, builders,\n            and specialty craftspeople our professional advice on scheduling, project management,\n            and cost-effectiveness\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            No matter the client, project or property size, Gulf Coast Landscape Services builds beautiful\n            and worry-free landscapes, with a customer experience to match. Since our founding in 1995,\n            that has been and remains our driving goal.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We partner with owners, architects and general contractors to ensure a finished product that\n            is delivered on time and on budget. We have experience with Industrial, Office, Retail,\n            Medical and Multi-Family, projects.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We work with Developers, General Contractors, Builders, Architectural Firms and large national\n            companies from start to finish on each project. Working within specific budgets and\n            timeframes, we ensure direct supervision on every job, for services that include:\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Our Services")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('ul', [_c('li', [_vm._v("Hardscape Installation")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'irrigation'
      }
    }
  }, [_vm._v("Irrigation Installations")])], 1), _vm._v(" "), _c('li', [_vm._v("Paver Installation")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'erosion'
      }
    }
  }, [_vm._v("Soil Erosion")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'trees'
      }
    }
  }, [_vm._v("Tree Relocation")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('ul', [_c('li', [_vm._v("Excavating")]), _vm._v(" "), _c('li', [_vm._v("Retaining  Walls")]), _vm._v(" "), _c('li', [_vm._v("Site Work")]), _vm._v(" "), _c('li', [_vm._v("Commercial Landscaping Build")]), _vm._v(" "), _c('li', [_vm._v("Commercial Irrigation Projects")]), _vm._v(" "), _c('li', [_vm._v("Arboriculture- Tree Services")]), _vm._v(" "), _c('li', [_vm._v("Landscape Planting")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/services/erosion-control#hydroseeding"
    }
  }, [_vm._v("Hydro-seeding")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f08d619"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/Landscape.vue
// module id = 157
// module chunks = 1